import { Badge, Button, Card, Col, Container, ListGroup, Row } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { useDispatch, useSelector } from "react-redux";
import { fetchOrders, selectAllOrders } from "../store/ordersSlice";
import { useEffect, useState } from "react";
import { getLocalizedDate } from "../../shared/helpers/localizationHelper";
import { useLocation, useNavigate } from "react-router-dom";
import InvoiceListView from "./InvoiceListView";

const InvoiceBlock = ({ tenantId, }) => {
  // 
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { accessToken } = useSelector((state) => state.auth);
  const users = useSelector((state) => state?.auth?.user);
  const currentTenant = useSelector((state) => state?.sharedSlice?.currentTenant)
  const orders = useSelector(selectAllOrders);
  const [orderData, setOrderData] = useState([]);


  

  useEffect(() => {
    if (orders && Array.isArray(orders)) {
      const sorted = [...orders].sort((a, b) => {
        const da = new Date(a.created_at);
        const db = new Date(b.created_at);
        if (isNaN(da.getTime()) || isNaN(db.getTime())) return 0;
        return db - da; // latest first
      });
      setOrderData(sorted);
    }
  }, [orders]);

  const handleRowClick = (data) => {

    navigate("/plan/default/" + data?.id);
  };

  const gridColumns = [
    {
      id: "id",
      name: "#",
      selector: (row) => row.id,
    },
    {
      id: "created_at",
      name: "Txn Date",
      selector: (row) => row.created_at,
      cell: (row) => {
        const isoDateString = row.created_at;
        return getLocalizedDate(isoDateString);
      },
      sortable: true,
    },
    {
      id: "order_number",
      name: "Order No.",
      selector: (row) => row.order_number,
    },
    {
      id: "grand_total",
      name: "Total",
      selector: (row) => row.grand_total,
    },
    {
      id: "paid_amount",
      name: "Paid",
      selector: (row) => row.paid_amount,
    },
    {
      id: "status",
      name: "Status",
      selector: (row) => (
        <Badge
          bg={
            row.status === "paid"
              ? "success"
              : row.status === "Partially Paid"
                ? "warning"
                : "danger"
          }
          style={{
            padding: "5px",
            borderRadius: "5px",
            color:
              row.status === "paid"
                ? "white"
                : row.status === "Partially Paid"
                  ? "black"
                  : "white",
          }}
        >
          {" "}
          {row.status}
        </Badge>
      ),
      sortable: true,
    },
    {
      id: "actions",
      name: "Actions",
      cell: (row) => {
        return (
          <div className="d-flex justify-content-evenly align-items-center">
            {row.status == "paid" ? (
              <Button className="px-7 py-1" disabled>
                Paid
              </Button>
            ) : row.status == "pending" ? (
              <Button variant="outline-primary px-7 py-1"
                onClick={() => handlePayment(row)}>Pay</Button>
            ) : (
              <Button className="px-7 py-1" variant="danger" disabled>
                Cancelled
              </Button>
            )}
          </div>
        );
      },
    },
  ];

  const [user, setUser] = useState({
    name: "",
    email: "",
    contact: "",
    customer_id: "",
    tenant_id: "",
  });

  useEffect(() => {
    if (users) {
      const userDetails = {
        name: users.name,
        email: users.email,
        customer_id: users.id,
        contact: users.phone,
        cust_tenant_id: currentTenant?.id,
      };
      setUser(userDetails);
    }
  }, [users]);




  const createSubscription = async (planId) => {
    const subscriptionData = {
      customer_id: user.customer_id,
      razorpay_plan_id: planId,
      total_count: 6,
      quantity: 1,
      customer_notify: 1,
      has_scheduled_changes: 1,
      tenant_id: tenantId,
    };

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}tenants/subscriptions`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Tenant': user.cust_tenant_id,
        },
        body: JSON.stringify(subscriptionData),
      });

      const data = await response.json();
      if (response.ok) {

        return data.subscription_id;
      } else {
        console.error('Failed to create subscription:', data);
        return null;
      }
    } catch (error) {
      console.error('Error creating subscription:', error);
      return null;
    }
  };

  const fetchRazorpayKey = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}tenants/razorpay-key`);
      const data = await response.json();
      return data.razorpay_key;
    } catch (error) {
      console.error('Error fetching Razorpay key:', error);
      return null;
    }
  };

  const handlePayment = async (row) => {
    const orderId = row.id;
    const planId = row.selected_plan?.id;
    const planPeriod = row.selected_plan?.period;

    if (!planId) {
      console.error("Plan ID is missing for the selected order.");
      return;
    }
    //const subscriptionId = await createSubscription(planId);
    //if (!subscriptionId) return;

    const RAZORPAY_KEY = await fetchRazorpayKey();
    if (!RAZORPAY_KEY) {
      console.error("Failed to fetch Razorpay key");
      return;
    }
    const amountInPaise = parseInt(row?.grand_total * 100);


    const options = {
      key: RAZORPAY_KEY,
      currency: "INR",
      amount: amountInPaise,
      name: user.name,
      description: "Test Transaction",
      handler: async function (response) {

        try {
          /*  const verifyResponse = await fetch(
               `${process.env.REACT_APP_API_URL}tenants/verification`,
               {
                   method: "POST",
                   headers: {
                     'Content-Type': 'application/json',
                     'Accept': 'application/json',
                     "X-Tenant": tenantId,
                   },
                   body: JSON.stringify({
                       razorpay_payment_id: response.razorpay_payment_id,
                       orderCreationId: orderId,
                       tenantId: tenantId,
                       period: planPeriod,
                       amount: row.grand_total,
                   }),
               }
           ); */

          const verifyResponse = await fetch(
            `${process.env.REACT_APP_API_URL}tenants/orders/confirm-payment`,
            {
              method: "POST",
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                "X-Tenant": tenantId,
                "Content-Type": "application/json",
                Authorization: `Bearer ${accessToken}`,
              },
              body: JSON.stringify({
                order_id: orderId,
                payment: {
                  reference_number: response.razorpay_payment_id,
                  amount: row.grand_total,
                  status: response.razorpay_payment_id ? 'paid' : 'failed',
                  response: response,
                }
              }),
            }
          );

          const data = await verifyResponse.json();


          if (response.razorpay_payment_id) {
            alert("Payment processed successfully");
            navigate('/billing');
            //window.location.reload();
          } else {
            alert("Payment process failed");
            //window.location.reload();
          }
        } catch (error) {
          console.error("Error:", error);
          alert("Payment process failed");
        }
      },
      prefill: {
        name: user.name,
        email: user.email,
        contact: user.contact,
      },
      notes: {
        address: "Corporate Office",
        plan_id: planId,
      },
      theme: {
        color: "#F37254",
      },
    };

    const rzp1 = new window.Razorpay({
      ...options,
      modal: {
        ondismiss: function () {
          alert("Payment process was cancelled");
          navigate("/billing");
        },
      },
    });
    rzp1.open(); // Directly open the Razorpay payment page
  };


  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    //
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);




  return !isMobile ? (
    <div className="px-0">
      {orderData && orderData.length > 0 ? (
        <DataTable
          data={orderData}
          columns={gridColumns}
          pagination={true}
          paginationPerPage={50}
          paginationRowsPerPageOptions={[50, 100, 150, 200, 250]}
          responsive
          highlightOnHover
          pointerOnHover
          handleSearch
          onRowClicked={handleRowClick}
        />
      ) : (
        <h4 className="text-center mt-3">No invoices yet</h4>
      )}
    </div>
  ) : (
    <div className="px-0">
      <InvoiceListView orderData={orderData} />
    </div>
  );
};

export default InvoiceBlock;
